import getEwsRequestDateString from './utils/getEwsRequestDateString';
import applyConversationActionRequest from 'owa-service/lib/factory/applyConversationActionRequest';
import conversationAction from 'owa-service/lib/factory/conversationAction';
import folderIdFactory from 'owa-service/lib/factory/folderId';
import itemId from 'owa-service/lib/factory/itemId';
import targetFolderIdFactory from 'owa-service/lib/factory/targetFolderId';
import applyConversationActionOperation from 'owa-service/lib/operation/applyConversationActionOperation';
import { getJsonRequestHeader } from 'owa-service/lib/Utils';
/**
 * Create the flag conversationAction for the given conversation
 * @param conversationContext the conversation context to be flagged
 * @param flagType the flag type to apply
 * @param folderId the sourceFolderId
 * @returns the generated ConversationAction
 */
function createFlagConversationAction(conversationContext, flagType, folderId) {
    var flagAction = conversationAction({
        Action: 'Flag',
        ConversationId: itemId({ Id: conversationContext.conversationId }),
        Flag: flagType,
        ConversationLastSyncTime: getEwsRequestDateString(conversationContext.conversationLastSyncTimeStamp),
    });
    // folderId can be null in search mode.
    if (folderId) {
        var targetFolderId = targetFolderIdFactory({
            BaseFolderId: folderIdFactory({
                Id: folderId,
            }),
        });
        flagAction.ContextFolderId = targetFolderId;
    }
    return flagAction;
}
/**
 * Configure the request body
 * @param conversationIds the conversation ids
 * @param flagType the flag type to apply
 * @param folderId the folder id
 * @returns an ApplyConversationActionRequest
 */
function configureRequestBody(conversationContexts, flagType, folderId) {
    var conversationActions = conversationContexts.map(function (conversationContext) {
        return createFlagConversationAction(conversationContext, flagType, folderId);
    });
    return applyConversationActionRequest({
        ConversationActions: conversationActions,
    });
}
/**
 * Sends out the service request to set flag on conversation
 * @param conversationContexts the conversation contexts to be deleted
 * @param flagType the flag type to apply
 * @param folderId the source folder id
 * @returns a Promise that handles the service request response
 */
export function flagConversationService(conversationContexts, flagType, folderId) {
    var requestBody = configureRequestBody(conversationContexts, flagType, folderId);
    return applyConversationActionOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
//# sourceMappingURL=flagConversationService.js.map